"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_1 = tslib_1.__importDefault(require("react"));
const react_components_1 = require("@apollo/react-components");
const react_select_1 = tslib_1.__importDefault(require("react-select"));
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../comps/reusables");
const AdminOnly_1 = require("../../../comps/reusables/AdminOnly");
const graphql_1 = require("../../../graphql");
const inputs_1 = require("../../../inputs");
const react_2 = require("@osmosys/react");
exports.EditAdForm = props => {
    const { data } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(reusables_1.Form, { mutationProps: {
                mutation: graphql_1.updateAd,
                onCompleted: () => {
                    setTimeout(() => {
                        props.onEditSave();
                    }, 500);
                },
            }, formikProps: {
                initialValues: {
                    availableContexts: (data && data.availableContexts) || [],
                    defaultContext: data && data.defaultContext,
                    html: data && data.html,
                    name: data && data.name,
                },
            }, valuesToVariables: values => {
                const contextIds = values.availableContexts.map(c => c.id);
                return {
                    data: {
                        availableContextIds: contextIds,
                        defaultContextId: values.defaultContext &&
                            contextIds.includes(values.defaultContext.id)
                            ? values.defaultContext.id
                            : null,
                        html: values.html,
                        name: values.name,
                    },
                    id: data && data.id,
                };
            } }, (formikProps, result) => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "Ad", action: "update", apolloError: result.error, errorPrefix: "Failed to save ad" }),
            react_1.default.createElement(reusables_1.FormGroup, { label: "Ad name", name: "name" }),
            react_1.default.createElement(reactstrap_1.FormGroup, null,
                react_1.default.createElement(reactstrap_1.Label, { className: "font-weight-bold" }, "Code"),
                react_1.default.createElement("div", { style: {
                        height: 300,
                        maxWidth: '100%',
                        overflow: 'hidden',
                    }, className: "border rounded" },
                    react_1.default.createElement(reusables_1.CodeEditor, { value: formikProps.values.html, onChange: h => {
                            formikProps.setFieldValue('html', h);
                        } }))),
            react_1.default.createElement(AdminOnly_1.AdminOnly, null,
                react_1.default.createElement("div", { className: "py-2 px-3 mb-2 border rounded" },
                    react_1.default.createElement(reactstrap_1.FormGroup, null,
                        react_1.default.createElement(reactstrap_1.Label, { className: "font-weight-bold" }, "Available contexts"),
                        react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, { resource: "context" })),
                    react_1.default.createElement(reactstrap_1.FormGroup, null,
                        react_1.default.createElement(reactstrap_1.Label, { className: "font-weight-bold" }, "Default context"),
                        react_1.default.createElement(react_select_1.default, { isClearable: true, onChange: newData => {
                                formikProps.setFieldValue('defaultContext', newData);
                            }, value: formikProps.values.defaultContext, options: formikProps.values.availableContexts || [], getOptionValue: opt => {
                                return `${opt.id}`;
                            }, getOptionLabel: opt => {
                                return opt.name;
                            } })))),
            react_1.default.createElement(reactstrap_1.Row, null,
                react_1.default.createElement(reactstrap_1.Col, { className: "justify-content-end d-flex flex-column flex-shrink-1 flex-grow-0" },
                    react_1.default.createElement(react_2.OsmosysTooltip, { label: "Delete ad" },
                        react_1.default.createElement(react_components_1.Mutation, { mutation: graphql_1.deleteAd, variables: { id: data && data.id }, onCompleted: () => {
                                props.onDelete();
                            } }, (mutate, deleteResult) => (react_1.default.createElement("div", { className: "" },
                            react_1.default.createElement(reusables_1.AjaxButton, { color: "danger", icon: pro_solid_svg_icons_1.faTrash, type: "button", size: "sm", loading: deleteResult.loading, error: deleteResult.error, success: !!deleteResult.data, onConfirmation: () => {
                                    mutate();
                                } })))))),
                react_1.default.createElement(reactstrap_1.Col, { className: "flex-grow-1 text-right" },
                    react_1.default.createElement(reusables_1.AjaxButton, { color: "success", type: "submit", successText: "Ad saved", label: "Save", loading: result.loading, error: result.error, success: !!result.data, size: "lg" }))))))));
};
//# sourceMappingURL=EditAdForm.js.map